import { render, staticRenderFns } from "./KpiAnimatedNumber.vue?vue&type=template&id=dcf0c338&scoped=true"
import script from "./KpiAnimatedNumber.vue?vue&type=script&lang=js"
export * from "./KpiAnimatedNumber.vue?vue&type=script&lang=js"
import style0 from "./KpiAnimatedNumber.vue?vue&type=style&index=0&id=dcf0c338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf0c338",
  null
  
)

export default component.exports